(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    var lazyLoadSlideshow = function () {
        // Lazy load all slideshow images after the initial
        [].forEach.call(document.querySelectorAll('.cycle-slideshow img[data-src]'),
            function (img) {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.setAttribute('srcset', img.getAttribute('data-srcset'));
                img.setAttribute('sizes', img.getAttribute('data-sizes'));
                img.onload = function () {
                    img.removeAttribute('data-src');
                    img.removeAttribute('data-srcset');
                    img.removeAttribute('data-sizes');
                };
            });
    };

    fp.home = (function () {
        return {
            init: function () {
                $('.homepage-link').addClass('selected');

                lazyLoadSlideshow();

                // =========================================
                // Carousel controls
                // =========================================

                const carouselWrapper = document.querySelector('.slideshow');
                const carouselTarget = document.querySelector('.cycle-slideshow');
                const ariaLiveRegion = document.querySelector('#control-announcements');

                // Ensure the carousel target exists and the cycle plugin is available
                if (!carouselTarget || typeof $.fn.cycle !== 'function') return;

                // Initialize the carousel
                $(carouselTarget).cycle();

                // Pause the carousel on mouseenter
                /*
                if (carouselWrapper) {
                    carouselWrapper.addEventListener('mouseenter', () => {
                        if (!carouselTarget.classList.contains('hard-pause')) {
                            $(carouselTarget).cycle('pause');
                        }
                    });

                    carouselWrapper.addEventListener('mouseleave', () => {
                        if (!carouselTarget.classList.contains('hard-pause')) {
                            $(carouselTarget).cycle('resume');
                        }
                    });
                }
                */

                // Handle the play/pause button
                const cyclePausePlay = document.querySelector('#cycle-pause-play');
                const cyclePausePlayIcon = cyclePausePlay ? cyclePausePlay.querySelector('span') : null;

                if (cyclePausePlay) {
                    cyclePausePlay.addEventListener('click', function () {
                        const isPaused = carouselTarget.classList.contains('hard-pause');

                        // Update play/pause state
                        if (isPaused) {
                            carouselTarget.classList.remove('hard-pause');
                            this.setAttribute('aria-label', 'Pause carousel');
                            if (cyclePausePlayIcon) {
                                cyclePausePlayIcon.classList.replace('icon-play', 'icon-pause');
                            }
                            ariaLiveRegion.textContent = 'Carousel is playing.';
                            $(carouselTarget).cycle('resume');
                        } else {
                            carouselTarget.classList.add('hard-pause');
                            this.setAttribute('aria-label', 'Play carousel');
                            if (cyclePausePlayIcon) {
                                cyclePausePlayIcon.classList.replace('icon-pause', 'icon-play');
                            }
                            ariaLiveRegion.textContent = 'Carousel is paused.';
                            $(carouselTarget).cycle('pause');
                        }
                    });
                }

                // Handle the "Back" button
                const cycleBack = document.querySelector('#cycle-back');
                if (cycleBack && ariaLiveRegion) {
                    cycleBack.addEventListener('click', () => {
                        ariaLiveRegion.textContent = 'Reading previous slide.';
                    });
                }

                // Handle the "Next" button
                const cycleNext = document.querySelector('#cycle-next');
                if (cycleNext && ariaLiveRegion) {
                    cycleNext.addEventListener('click', () => {
                        ariaLiveRegion.textContent = 'Reading next slide.';
                    });
                }
            }
        };
    })();

})(window, $);